import React from 'react';
import {
  STEPS, initialForm, StepPersonal, StepEmergency, StepInsurance, StepClinical, StepConsents,
} from '../components/IntakeQuestionnaire';

// Uses the client's question panels with blank values. No client records are read.
const ignoreChange = () => {};
const panels = [StepPersonal, StepEmergency, StepInsurance, StepClinical, StepConsents];

export default function IntakePreview() {
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8 sm:px-8">
      <div className="mx-auto max-w-3xl">
        <h1 className="text-2xl font-bold text-brand-900">Intake Questionnaire Preview</h1>
        <p className="mt-3 text-sm leading-relaxed text-gray-700">
          Review the questions clients see in Client Intake. This is a blank, read-only preview;
          it does not display client information or save responses.
        </p>
        <p className="mt-2 text-sm text-gray-600">
          A red asterisk marks a required answer. Insurance details are required for private insurance
          and Medicaid / MediCal. The medication list is required when a client answers Yes.
          These conditional questions are all shown here for reference.
        </p>
        <p className="mt-2 text-sm text-gray-600">
          Completed responses are under My Clients → select a client → Clinical Information.
          The separate Self-Assessment symptom screening is not part of this intake preview.
        </p>
        <div className="mt-6 space-y-6">
          {panels.map((Panel, index) => (
            <section key={STEPS[index]} className="rounded-xl border border-gray-200 bg-white p-5 sm:p-8">
              <h2 id={`preview-section-${index}`} className="mb-6 text-lg font-semibold text-brand-900">
                {index + 1}. {STEPS[index]}
              </h2>
              <fieldset disabled aria-labelledby={`preview-section-${index}`}>
                <Panel form={initialForm} handle={ignoreChange} currentUser={{}} preview />
              </fieldset>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
